import React, { useContext} from "react";
import {GlobalContext} from "../context/GlobalState";



const Balance = () => {
    const {transactions} = useContext(GlobalContext);

    const amounts = transactions.map(transaction =>(transaction.amount));

    const total = amounts.reduce((total,currentValue)=> (total = total + currentValue),0).toFixed(3);
    return(
            <div>
                <h4>Your Balance</h4>
                <h1 id="balance">+${total}</h1>
            </div>
    )
}

export default Balance;